import { Collapse, CollapseProps } from "antd";
import BrandLogo1 from "../../../assets/web/images/logo-1.png";
import BrandLogo2 from "../../../assets/web/images/logo-2.png";
import BrandLogo3 from "../../../assets/web/images/logo-3.png";
import BrandLogo4 from "../../../assets/web/images/logo-4.png";
import BrandLogo5 from "../../../assets/web/images/logo-5.png";
import Shape3 from "../../../assets/web/images/shape-3.svg";
import Shape5 from "../../../assets/web/images/shape-5.svg";
import BannerContainer from "../../../components/web/common/BannerContainer";
import PricingCards from "../../../components/web/common/PricingCards";
import Container from "../../../components/web/Container";
import PublicLayout from "../../../layouts/PublicLayout";

const items: CollapseProps["items"] = [
  {
    key: "1",
    label:
      "Do I really have access to hundreds of apps and modules for a single price?",
    children: <p>Yes, you are not dreaming.</p>,
  },
  {
    key: "2",
    label: "What's included in the subscription?",
    children: <p></p>,
  },
  {
    key: "3",
    label: "What is Sheba Business?",
    children: <p></p>,
  },
  {
    key: "4",
    label:
      "Where can I get implementation services, and how much does it cost?",
    children: <p></p>,
  },
  {
    key: "5",
    label:
      "How to upgrade from the digiGO Free plan to a Standard or Custom plan?",
    children: <p></p>,
  },
  {
    key: "6",
    label: "How do you define a paying user?",
    children: <p></p>,
  },
];

export default function Pricing() {
  const brandLogos = [
    BrandLogo1,
    BrandLogo2,
    BrandLogo3,
    BrandLogo4,
    BrandLogo5,
  ];

  return (
    <PublicLayout title="Pricing | Sheba Business Portal">
      <BannerContainer>
        <div className="text-center text-4xl md:text-6xl font-bold text-textHeading">
          <span className="md:block">Choose the right plan</span>
          <span className="relative">
            <span> for your team</span>
            <img
              src={Shape3}
              alt=""
              className="absolute top-2 -right-[20px] -z-10"
            />
          </span>
        </div>

        <div className="max-w-3xl mx-auto mt-10">
          <div className="grid grid-cols-3 md:grid-cols-5 gap-4">
            {brandLogos.map((logo, index) => (
              <div
                key={index}
                className="bg-white p-4 rounded-md shadow-md flex items-center justify-center"
              >
                <img src={logo} className="w-full" alt="Sheba" />
              </div>
            ))}
          </div>
        </div>
      </BannerContainer>
      <section className="py-16">
        <PricingCards />
      </section>
      <section className="py-16">
        <Container>
          <div className="mt-16 mb-12 text-4xl md:text-5xl font-bold text-center text-textHeading">
            <span className="">Any </span>

            <span className="relative">
              <span className="relative z-10">Questions?</span>
              <img src={Shape5} alt="" className="absolute -bottom-2 left-6" />
            </span>
          </div>

          <div className="max-w-3xl mx-auto mt-10">
            <Collapse className="" items={items} defaultActiveKey={["1"]} />
          </div>
        </Container>
      </section>
    </PublicLayout>
  );
}
